// extracted by mini-css-extract-plugin
module.exports = {"container":"app_container__2OT0C"};